const isFrenchLocale = () => {
  return window.Shopify.locale === `fr`
}

export { isFrenchLocale }
